<template>
  <div>
    <div class="flex items-center min-h-screen" v-if="loading">
      <van-loading class="text-center mx-auto" size="50px" />
    </div>
    <div class="container" v-if="!loading">
      <div class="arrow">
        <img :src="share" />
      </div>
      <div class="block">
        <p class="p-4 text-base">点击右上角【...】菜单</p>
        <p class="p-4 text-base">选择【发送给朋友】，快速拼团</p>
        <p class="img">
          <img :src="shares">
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import share from '@/assets/images/share.png'
import shares from '@/assets/images/share-example.png'
export default {
  data () {
    return {
      share,
      shares
    }
  },
  computed: {
    loading () {
      return this.$store.state.loading
    },
    wxReady () {
      return this.$store.state.wxReady
    },
    id () {
      return this.$route.params.id
    },
    groupon () {
      return this.$store.state.groupon
    },
    title () {
      return '我正在纵购拼团'
    },
    desc () {
      let desc = '快来加入拼团,享受优惠吧.  '
      if (typeof this.groupon.title !== 'undefined') {
        desc = desc + this.groupon.title
      }
      if (typeof this.groupon.desc !== 'undefined') {
        desc = desc + ' 拼团价只要：' + this.groupon.price
      }
      return desc
    },
    imgUrl () {
      let img = 'https://m.yooshifu.com/images/groupon/504193747eb397d375a0c9e043ea02ef.jpeg'
      if (typeof this.groupon.images !== 'undefined') {
        img = this.groupon.images[0].image
      }
      return img
    }
  },
  created () {
    if (this.$h.empty(this.groupon)) {
      this.$store.dispatch('getGroupon', this)
    }
    if (this.wxReady) {
      this.shareInfo()
    }
    if (!this.wxReady) {
      this.gettoken()
    }
  },
  methods: {
    shareInfo () {
      let that = this
      wx.updateAppMessageShareData({
        title: that.title, // this.order.groupon.title, // 分享标题
        desc: that.desc, // this.order.groupon.title, // 分享描述
        link: 'https://m.yooshifu.com/groupon.html?#/groupons/' + this.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: that.imgUrl, // this.order.groupon.images[0].image, // 分享图标
        success: function () {
          console.log('分享好友')
        }
      })
      wx.updateTimelineShareData({
        title: that.title,
        desc: that.desc,
        link: 'https://m.yooshifu.com/groupon.html?#/groupons/' + this.id,
        imgUrl: that.imgUrl, // 分享图标
        success: function () {
          console.log('分享朋友圈')
        }
      })
    }, // end of shareInfo
    gettoken () {
      let url = 'https://m.yooshifu.com/groupon.html?'
      let params = {
        params: {
          appurl: url
        }
      }
      this.$http.get(this.$api.wxtoken, params).then(res => {
        let { data, status } = res
        if (status) {
          return this.$h.handleError(res)
        }
        this.$store.commit('updateWxToken', data)
        let that = this
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['scanQRCode', 'getLocation', 'chooseWXPay', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
        })
        wx.ready(() => {
          that.shareInfo()
          that.$store.commit('updateWxState', true)
        })
      })
    } // end of get token
  } // end of methods
}
</script>
<style scoped>
.container {
  text-align: center;
  padding: .6rem 0;
}
.arrow {
  position: absolute;
  height: 16rem;
  right: .6rem;
  top: 0;
}
.content {
  font-size: .4rem;
  font-weight: bold;
  padding: .2rem .4rem;
  text-align: left;
}
.block {
  margin-top: 20px;
}
.img {
  padding:20px;
  margin-top: 20px;
}
.img img{
  width: 100%;
}
</style>
